import initialState from "./InitialState"
import {
    CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS,
    FETCH_APPOINTMENTS_FOR_PATIENT_SUCCESS,
    FETCH_PATIENT_ALLERGY_SUCCESS, FETCH_PATIENT_COMORBID_CONDITIONS_SUCCESS,
    FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS, FETCH_PATIENT_CONCERNS_SUCCESS,
    FETCH_PATIENT_CURRENT_MEDICATION_SUCCESS,
    FETCH_PATIENT_HABIT_SUCCESS, FETCH_PATIENT_LAB_TESTS_SUCCESS, FETCH_PATIENT_PERSONAL_INFORMATION_SUCCESS,
    FETCH_PATIENT_PROFILE_SUCCESS,
    FETCH_PATIENT_SURGERY_SUCCESS, FETCH_PATIENT_TYPE_FORM_DATA_SUCCESS,
    FETCH_PATIENT_VITALS_SUCCESS, FETCH_RED_FLAGS_SUCCESS, SAVE_PATIENT_ALLERGY_SUCCESS,
    SAVE_PATIENT_COMORBID_CONDITIONS_SUCCESS,
    SAVE_PATIENT_CURRENT_MEDICATION_SUCCESS,
    SAVE_PATIENT_HABIT_SUCCESS,
    SAVE_PATIENT_SURGERY_SUCCESS,
    SAVE_PATIENT_VITALS_SUCCESS,
    SAVE_PATIENT_ADHERENCE_DATA, SAVE_ADHERENCE_ACTIVITY_DATA,
    SAVE_PATIENT_PLAN_VIEW,
    SAVE_PATIENT_GOALS_VIEW, SAVE_PATIENT_METRICS_DATA,
    SAVE_PATIENTS_OVERALL_ADHERENCE_SCORES,
    SAVE_PATIENT_LAB_TESTS_SUCCESS,
    SAVE_PATIENT_LAB_TESTS, SAVE_PAST_CONSULTATION_DATA,
} from "../actions/ActionTypes"
import {combineReducers} from "redux"
import AppUtils from "../utils/AppUtils";
import {isEmpty as _isEmpty} from "lodash";

/**
 * Created by abhinav on 26/01/18.
 */

const PatientVitalsReducer = function (state = initialState.patientCompleteInfo.vitals, action: any) {
    switch (action.type) {
        /*case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign([], action.patientCompleteDetails.patientVitalList);*/
        case FETCH_PATIENT_VITALS_SUCCESS:
            return Object.assign([], action.patientVitals);
        case SAVE_PATIENT_VITALS_SUCCESS:
            return state;
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        default:
            return state
    }
}

const PatientProfileReducer = function (state = initialState.patientCompleteInfo.profile, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign({}, action.patientCompleteDetails.patientDetail);
        case FETCH_PATIENT_PROFILE_SUCCESS:
            return Object.assign({}, action.patientProfile);
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        default:
            return state;
    }
}


const PatientHabitsReducer = function (state = initialState.patientCompleteInfo.habits, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign([], action.patientCompleteDetails.patientHabitList);
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        case FETCH_PATIENT_HABIT_SUCCESS:
            return Object.assign([], action.patientHabitsList);
        case SAVE_PATIENT_HABIT_SUCCESS:
            return Object.assign([], action.patientHabitsList);
        default:
            return state;
    }
}

const PatientSurgeryAndProcedureReducer = function (state = initialState.patientCompleteInfo.surgeryAndProcedure, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign([], action.patientCompleteDetails.patientSurgeryAndProcedureList);
        case FETCH_PATIENT_SURGERY_SUCCESS:
            return Object.assign([], action.surgeryData);
        case SAVE_PATIENT_SURGERY_SUCCESS:
            return Object.assign([], action.surgeryData);
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        default:
            return state;
    }
}

const PatientAllergiesReducer = function (state = initialState.patientCompleteInfo.allergies, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign([], action.patientCompleteDetails.patientAllergyList);
        case FETCH_PATIENT_ALLERGY_SUCCESS:
            return Object.assign([], action.patientAllergies);
        case SAVE_PATIENT_ALLERGY_SUCCESS:
            return Object.assign([], action.patientAllergies);
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        default:
            return state;
    }
}

const PatientCurrentMedicationReducer = function (state = initialState.patientCompleteInfo.currentMedication, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign([], action.patientCompleteDetails.patientCurrentMedicationList);
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        case FETCH_PATIENT_CURRENT_MEDICATION_SUCCESS:
            return Object.assign([], action.currentMedication);
        case SAVE_PATIENT_CURRENT_MEDICATION_SUCCESS:
            return Object.assign([], action.currentMedications);
        default:
            return state;
    }
}

const PatientComorbidConditionReducer = function (state = initialState.patientCompleteInfo.comorbidCondition, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign([], action.patientCompleteDetails.patientComorbidConditionList);
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        case FETCH_PATIENT_COMORBID_CONDITIONS_SUCCESS:
            return Object.assign([], action.comorbidConditions);
        case SAVE_PATIENT_COMORBID_CONDITIONS_SUCCESS:
            return Object.assign([], action.comorbidConditions);
        default:
            return state;
    }
}

const PatientAllConsultations = function (state = initialState.patientCompleteInfo.consultations, action: any) {
    switch (action.type) {
        case FETCH_APPOINTMENTS_FOR_PATIENT_SUCCESS:
            return Object.assign({}, action.appointments)
        case SAVE_PAST_CONSULTATION_DATA:
            if (!_isEmpty(state) && !_isEmpty(state[`cons-${action.payload.consultationId}`])) {
                return {
                    ...state,
                    [`cons-${action.payload.consultationId}`]: {
                        ...(state[`cons-${action.payload.consultationId}`]),
                        ...action.payload.data
                    }
                }
            }
            return {...state}
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        default:
            return state;
    }
}

const PatientConditionsReducer = function (state = initialState.patientCompleteInfo.conditions, action: any) {
    switch (action.type) {
        default:
            return state;
    }
}

const PatientLabTestsReducer = function (state = initialState.patientCompleteInfo.labTests, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_LAB_TESTS_SUCCESS:
            return Object.assign([], action.patientLabTests)
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        case SAVE_PATIENT_LAB_TESTS:
            return Object.assign([], action.patientLabTests)
        case SAVE_PATIENT_LAB_TESTS_SUCCESS:
            return Object.assign([], action.patientLabTests)
        default:
            return state;
    }
}

const PatientConcernsReducer = function (state = initialState.patientCompleteInfo.concerns, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign([], action.patientCompleteDetails.patientConcernList)
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        case FETCH_PATIENT_CONCERNS_SUCCESS:
            return Object.assign([], action.patientConcerns)
        default:
            return state;
    }
}

const PatientRedFlagsReducer = function (state = initialState.patientCompleteInfo.redFlags, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return Object.assign([], action.patientCompleteDetails.patientRedFlagList)
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        case FETCH_RED_FLAGS_SUCCESS:
            return Object.assign([], action.patientRedFlags)
        default:
            return state;
    }
}

const PatientPersonalInformationReducer = function (state = initialState.patientCompleteInfo.personalInfo, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_PERSONAL_INFORMATION_SUCCESS:
            return Object.assign({}, action.patientPersonalInfo)
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        default:
            return state;
    }
}

const PatientTypeFormDataReducer = function (state = initialState.patientCompleteInfo.typeFormData, action: any) {
    switch (action.type) {
        case FETCH_PATIENT_TYPE_FORM_DATA_SUCCESS:
            return Object.assign({}, action.patientTypeFormData)
        case CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS:
            return null;
        default:
            return state;
    }
}

const PatientAdherenceData = function(state = initialState.patientCompleteInfo.adherenceData, action: any) {
    switch (action.type) {
        case SAVE_PATIENT_ADHERENCE_DATA:
            return { ...action.payload }
        default:
            return state
    }
}

const PatientAdherenceActivityData = function (state = initialState.patientCompleteInfo.activityDishesMap, action: any) {
    switch (action.type) {
        case SAVE_ADHERENCE_ACTIVITY_DATA:
            return { ...action.payload }
        default:
            return state
    }
}

const PateintPlanViewData = (state = initialState.patientCompleteInfo.patientPlan, action: any) => {
    switch (action.type) {
        case SAVE_PATIENT_PLAN_VIEW:
            return {...action.payload}
        default:
            return state
    }
};

const PatientGoalsViewData = (state = initialState.patientCompleteInfo.patientGoals, action: any) => {
    switch (action.type) {
        case SAVE_PATIENT_GOALS_VIEW:
            return [...action.payload]
        default:
            return state
    }
};

const PatientMetricsData = (state = initialState.patientCompleteInfo.patientMetrics, action: any) => {
    switch (action.type) {
        case SAVE_PATIENT_METRICS_DATA:
            let patientMetrics = AppUtils.isDefined(state) ? {...state} : {};
            patientMetrics[action.payload.metricId] = action.payload.data;
            return { ...patientMetrics };
        default:
            return state
    }
}

const PatientsOverallAdherenceScore = (state = initialState.patientCompleteInfo.adherenceScores, action: any) => {
    switch (action.type) {
        case SAVE_PATIENTS_OVERALL_ADHERENCE_SCORES:
            let overallScores = AppUtils.getDeepCopiedObject(state);
            for (const key in action.payload) {
                overallScores[key] = {...overallScores[key] || {}, ...action.payload[key]}
            }
            return {...overallScores};
        default:
            return state
    }
}

export const PatientCompleteInfoReducer = combineReducers({
    profile: PatientProfileReducer,
    vitals: PatientVitalsReducer,
    habits: PatientHabitsReducer,
    concerns: PatientConcernsReducer,
    redFlags: PatientRedFlagsReducer,
    surgeryAndProcedure: PatientSurgeryAndProcedureReducer,
    allergies: PatientAllergiesReducer,
    currentMedication: PatientCurrentMedicationReducer,
    comorbidCondition: PatientComorbidConditionReducer,
    conditions: PatientConditionsReducer,
    consultations: PatientAllConsultations,
    labTests: PatientLabTestsReducer,
    personalInfo: PatientPersonalInformationReducer,
    typeFormData: PatientTypeFormDataReducer,
    adherenceData: PatientAdherenceData,
    activityDishesMap: PatientAdherenceActivityData,
    patientPlan: PateintPlanViewData,
    patientGoals: PatientGoalsViewData,
    patientMetrics: PatientMetricsData,
    adherenceScores: PatientsOverallAdherenceScore
})